import { cn } from "../helpers/Common";

export const DEFAULT_TABLE_THEME = cn(
  "table-header-regular relative hover:text-gray-500 hover:transition-all hover:duration-300 hover:ease-in-out hover:bg-brand-accent"
);
